import React, { useEffect, useState } from "react";
import Header from "../../../components/landingPage/Header";
import SideBar from "../../../components/b2b/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faDownload,
} from "@fortawesome/fontawesome-free-solid";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import "./creditCard.css";
import CsvDownload from "react-csv-downloader";
import { Skeleton } from "@mui/material";

const CreditCardDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { token } = useSelector((state) => state.auth);
  const { creditCardDetail, creditCardDetailLoading } = useSelector(
    (state) => state.creditcard
  );
  const [startDate, setstartDate] = useState();
  const [endDate, setendDate] = useState();

  useEffect(() => {
    dispatch({
      type: "GET_CREDIT_CARD_DETAIL",
      payload: {
        token,
        id,
      },
    });
  }, []);

  // useEffect(() => {
  //   if (startDate && endDate) {
  //     dispatch({
  //       type: "GET_CREDIT_CARD_DETAIL",
  //       payload: {
  //         token,
  //         id,
  //         startDate,
  //         endDate,
  //       },
  //     });
  //   } else {
  //     dispatch({
  //       type: "GET_CREDIT_CARD_DETAIL",
  //       payload: {
  //         token,
  //         id,
  //       },
  //     });
  //   }
  // }, [startDate, endDate, dispatch, token, id]);

  const search = () => {
    dispatch({
      type: "GET_CREDIT_CARD_DETAIL",
      payload: {
        token,
        id,
        startDate,
        endDate,
      },
    });
  };

  const reset = () => {
    dispatch({
      type: "GET_CREDIT_CARD_DETAIL",
      payload: {
        token,
        id,
      },
    });
  };

  return (
    <div className="credit-card h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className=" w-full px-10 py-2">
          <div className="">
            <Link to="/creditcard">
              <FontAwesomeIcon
                icon={faArrowAltCircleLeft}
                className="h-5 w-5 cursor-pointer"
              />
            </Link>
          </div>
          <div className="pt-10">
            <div className="flex space-x-1  items-center">
              <div className="text-sm  text-gray-600">Card Number :</div>
              <div className="font-semibold">
                xxxx-xxxx-xxxx-
                {creditCardDetail?.creditCard?.cardNumberLastFour}
              </div>
            </div>
            <div className="flex space-x-1  items-center">
              <div className="text-sm  text-gray-600">Holder Name :</div>
              <div className="text-base">
                {creditCardDetail?.creditCard?.name}
              </div>
            </div>
            <div className="flex space-x-1  items-center ">
              <div className="text-sm  text-gray-600">Bank Name :</div>
              <div className="text-sm">
                {creditCardDetail?.creditCard?.bank}
              </div>
            </div>
          </div>
          <div className="pt-3">
            <div className="flex justify-between items-center border-b border-spacing-2 border-secondary">
              <div className="text-xl font-semibold text-secondary">
                Transactions {creditCardDetail?.creditCards?.length}
              </div>
              <div className=" space-x-2 items-center">
                <div className="text-base text-center font-semibold border-b">
                  Filter
                </div>
                <div className="flex space-x-3 py-1">
                  <div>
                    <div className="text-sm font-semibold text-gray-600">
                      Start Date
                    </div>
                    <input
                      type="date"
                      id="statDate"
                      className="textField text-sm"
                      onChange={(e) => {
                        setstartDate(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-600">
                      End Date
                    </div>
                    <input
                      type="date"
                      className="textField text-sm"
                      onChange={(e) => {
                        setendDate(e.target.value);
                      }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      search();
                    }}
                    className="cursor-pointer bg-teal-600 hover:bg-teal-800 px-2 h-min py-1 text-white text-sm rounded-sm"
                  >
                    Search
                  </div>
                  <div
                    onClick={reset}
                    className="cursor-pointer text-sm border border-teal-600 h-min px-2 py-0.5 rounded-sm"
                  >
                    Reset
                  </div>
                </div>
              </div>
              <CsvDownload
                filename={`Card-${
                  creditCardDetail?.creditCard?.name +
                  " " +
                  creditCardDetail?.creditCard?.bank +
                  " " +
                  creditCardDetail?.creditCard?.cardNumberLastFour
                }`}
                extension=".csv"
                separator=","
                datas={creditCardDetail?.creditCards?.map((item) => {
                  return {
                    "Payment Date": moment(item.createdAt).format("DD-MM-YYYY"),
                    "Booking ID": item.bookingId,
                    "Card Details": item.cardDetail,
                    "Affiliate Details": item.affiliateDetails,
                    Currency: item.currency,
                    Amount: item.amount,
                  };
                })}
                columns={[
                  "Payment Date",
                  "Booking ID",
                  "Card Details",
                  "Affiliate Details",
                  "Currency",
                  "Amount",
                ]}
              >
                <div className="flex space-x-2 items-center bg-teal-600 px-2 py-1 rounded-sm text-white hover:bg-teal-800 cursor-pointer">
                  <FontAwesomeIcon icon={faDownload} />
                  <div>Download</div>
                </div>
              </CsvDownload>
            </div>
            <div className=" relative overflow-y-scroll max-h-screen scrollbar">
              <table style={{ marginLeft: "auto", marginRight: "auto" }}>
                <thead className="border-b space-y-7 text-gray-800">
                  <tr className="bg-slate-200">
                    <th className="text-base ">No</th>
                    <th className="text-base ">Payment Date</th>
                    <th className="text-base ">Booking ID</th>
                    <th className="text-base ">Card Details</th>
                    <th className="text-base ">Affiliate Details</th>
                    <th className="text-base ">Currency </th>
                    <th className="text-base ">Amount </th>
                  </tr>
                </thead>
                <tbody>
                  {!creditCardDetailLoading ? (
                    creditCardDetail?.creditCards?.map((item, index) => (
                      <tr key={index} className="border mx-auto rounded-md ">
                        <td className="text-center text-sm">{index + 1}</td>
                        <td className="border text-center font-sans py-1 text-sm text-teal-700 font-semibold">
                          {moment(item?.paymentDate).format("DD-MM-YYYY")}
                        </td>
                        <td className="border text-center w-28 font-sans text-sm ">
                          {item?.bookingId}
                        </td>
                        <td className="border text-center font-sans text-sm">
                          {item?.cardDetail}
                        </td>
                        <td className="border text-center font-sans text-sm">
                          {item?.affiliateDetails}
                        </td>
                        <td className="border text-center w-3 font-sans text-sm text-orange-600">
                          {item.currency}
                        </td>
                        <td className="border text-center font-sans text-sm text-teal-800 font-semibold">
                          {item.amount}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="border mx-auto rounded-md ">
                      <td className="text-center text-sm px-2">
                        {" "}
                        <Skeleton animation="wave" />
                      </td>
                      <td className="border px-2 text-center font-sans py-1 text-sm text-teal-700 font-semibold">
                        <Skeleton animation="wave" />
                      </td>
                      <td className="border px-2 text-center w-72 font-sans text-sm ">
                        <Skeleton animation="wave" />
                      </td>
                      <td className="border px-2 text-center font-sans text-sm">
                        <Skeleton animation="wave" />
                      </td>
                      <td className="border  px-2 text-center font-sans text-sm">
                        <Skeleton animation="wave" />
                      </td>
                      <td className="border px-2 text-center w-20 font-sans text-sm text-orange-600">
                        <Skeleton animation="wave" />
                      </td>
                      <td className="border px-2 text-center font-sans text-sm text-teal-800 font-semibold">
                        <Skeleton animation="wave" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCardDetails;
